// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import AnnouncementCreate from './AnnouncementCreate';
import BobPage from '../../../components/BobPage';
import AnnouncementTableContainer from './AnnouncementTableContainer';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import * as DashboardActions from '../../../actions/dashboardActions';
import { isEmpty } from 'lodash';
import { setPageTitle } from '../../../helpers/auth';

import classes from './AnnouncementsPage.module.css';

const AnnouncementsPage = ({
    activeNavCompany,
    history,
    ...props
}) => {

    const [announcementCreate, setAnnouncementCreate] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            if (announcementCreate) {
                setPageTitle(activeNavCompany.name, 'New Announcement');
            } else {
                setPageTitle(activeNavCompany.name, 'Announcements');
            }
        }
    }, [activeNavCompany, announcementCreate]);

    const handleBackClick = () => {
        setAnnouncementCreate(false);
        setSelectedAnnouncement(null);
    };

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    {
                        selectedAnnouncement || announcementCreate ?
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                {announcementCreate ? 'New Announcement' : `${selectedAnnouncement.title}`}
                            </span> : 'Announcements'
                    }
                </div>

                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    {
                        selectedAnnouncement || announcementCreate ?
                            <AnnouncementCreate
                                announcementCreate={announcementCreate} handleBackClick={handleBackClick} selectedAnnouncement={selectedAnnouncement} 
                            />:
                            <AnnouncementTableContainer
                                announcementCreate={announcementCreate}
                                setAnnouncementCreate={setAnnouncementCreate}
                                setSelectedAnnouncement={setSelectedAnnouncement}
                            /> 
                            
                    }
                    
                </div>
            </div>
        </BobPage>
    );
};

AnnouncementsPage.defaultProps = {
};

AnnouncementsPage.propTypes = {
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnnouncementsPage));
